'use client';

import { getClientApplicationContext } from '@hc-frontend/core-context';
import type { EventBusListener } from '@hc-frontend/core-events';
import { useEventBus } from '@hc-frontend/core-ui';
import {
  createDatadogPublisherCount,
  trackCountMetric,
} from '@hc-frontend/features-performance-monitoring';
import { useCallback, useEffect } from 'react';

import type {
  SendMetricEvent,
  SendMetricEventTarget,
} from './metrics-subscription.types';

export function MetricsSubscription({ source }: { source: string }) {
  const eventBus = useEventBus();

  const handleSendMetric = useCallback<
    EventBusListener<SendMetricEvent, SendMetricEventTarget>
  >(
    (event) => {
      const tags: Record<string, string | number | boolean> = {
        ...event.metric.tags,
        lead_source: source,
      };

      const context = getClientApplicationContext(MetricsSubscription);

      const publish = createDatadogPublisherCount(context.log);
      trackCountMetric(
        { publish, log: context.log },
        { ...event.metric, tags },
      );
    },
    [source],
  );

  useEffect(() => {
    eventBus.subscribe('metric.client.message', handleSendMetric);

    return () => {
      eventBus.unsubscribe('metric.client.message', handleSendMetric);
    };
  }, [handleSendMetric, eventBus]);

  return null;
}
